import { adaptAccessToken } from '~domain/helper/authentication/access-token-payload-adapter';
import {
  AuthenticationPayloadBase,
  AuthenticationPayloadV2,
} from '~domain/model/authentication/authentication-payload';

export function decodeAccessToken(accessToken: string): AuthenticationPayloadV2 {
  const payload = decodePayload(accessToken);
  return adaptAccessToken(payload);
}

function decodePayload(accessToken: string): AuthenticationPayloadBase {
  const tokenParts = accessToken.split('.')[1];
  const base64 = tokenParts.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}
